import React from "react";

// Flat line drawings in the brand palette. Stroke only, no fills, no 3D.
const base = {
  viewBox: "0 0 64 64",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const LeadsIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="8" y="12" width="34" height="40" rx="3" />
    <path d="M16 24h18M16 32h18M16 40h10" />
    <circle cx="48" cy="40" r="9" />
    <path d="m44.5 40 2.5 2.5 4.5-5" />
  </svg>
);

export const ReplyIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M10 16h44v26H28l-10 9v-9h-8z" />
    <path d="M22 26h20M22 34h12" />
  </svg>
);

export const FollowUpIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M14 30a18 18 0 1 1 5 12" />
    <path d="M19 32v10H9" />
    <path d="M32 22v11l7 5" />
  </svg>
);

export const CalendarIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="10" y="14" width="44" height="38" rx="3" />
    <path d="M10 26h44M22 10v8M42 10v8" />
    <path d="m26 38 4 4 9-9" />
  </svg>
);

export const ReportIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="10" y="10" width="44" height="44" rx="3" />
    <path d="M20 42V30M32 42V20M44 42V34" />
  </svg>
);

export const SaasIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="8" y="14" width="48" height="30" rx="3" />
    <path d="M20 52h24M32 44v8M18 24h12M18 32h20" />
  </svg>
);

export const ClinicIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 54V22l20-10 20 10v32" />
    <path d="M32 28v14M25 35h14" />
  </svg>
);

export const EducationIcon = (props) => (
  <svg {...base} {...props}>
    <path d="m32 14 24 10-24 10L8 24z" />
    <path d="M18 29v12c0 4 6 7 14 7s14-3 14-7V29" />
  </svg>
);

export const FitnessIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 26v12M20 22v20M44 22v20M52 26v12M20 32h24" />
  </svg>
);

export const MapIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M8 18l16-6 16 6 16-6v34l-16 6-16-6-16 6z" />
    <path d="M24 12v34M40 18v34" />
  </svg>
);
